import React from 'react';
import DraggableTileGrid from '../DraggableTileGrid/DraggableTileGrid';
import GenreCard from '../GenreCard/GenreCard';
import SkeletonCard from '../SkeletonCard/SkeletonCard';
import { isMobile } from 'react-device-detect';
import './GenresTile.scss';

const GenresTile = ({
  genres = [],
  onCategoryClick = () => {},
  title = '',
  viewAllText = '',
  onViewAllClick = () => {},
  isLoading = false,
  skeletonCount = isMobile ? 6 : 12,
  maxColumns = null,
}) => {
  const config = {
    itemsPerColumn: isMobile ? 3 : 2,
    columnWidth: isMobile ? 146 : 160,
    minColumnsInView: isMobile ? 2 : 6,
  };

  const renderGenre = (genre) => <GenreCard genre={genre} />;
  const renderSkeleton = () => <SkeletonCard variant="genre" />;

  const items = isLoading 
    ? Array.from({ length: skeletonCount }, (_, index) => ({
        id: `skeleton-genre-${index}`,
      }))
    : genres;

  const renderItem = isLoading ? renderSkeleton : renderGenre;
  const displayTitle = isLoading ? (title || 'קטגוריות') : title;

  return (
    <DraggableTileGrid
      items={items}
      onItemClick={isLoading ? () => {} : onCategoryClick}
      title={displayTitle}
      itemsPerColumn={config.itemsPerColumn}
      columnWidth={config.columnWidth}
      renderItem={renderItem}
      className={`genres-tile ${isLoading ? 'skeleton-loading' : ''}`}
      minColumnsInView={config.minColumnsInView}
      viewAllText={isLoading ? '' : viewAllText}
      onViewAllClick={isLoading ? () => {} : onViewAllClick}
      maxColumns={maxColumns}
      mobileSlidesPerView={2.2}
      initialOffset={isMobile ? 18 : 0}
      slidesOffsetAfter={isMobile ? 18 : 0}
    />
  );
};

export default GenresTile;
